export const IMAGE_MAP = {
    DESKTOP: "desktopImage",
    MSITE: "image"
};

export const parseExclusiveServices = (services, deviceType) => {
    if (!services || !deviceType) return [];

    return services.filter(service => {
        if (service[deviceType]) {
            service.imageURL = service[deviceType];
            return true;
        }
        return false;
    }
    );
};
